export const adminNext = {
  title: "Admin Dashboard",
  selectTool: "Select an admin tool:",
  panelPacksTitle: "Panel Packs Configuration",
  panelPacksDescription: "Manage scheduled comic panel packs for the mobile app",

  panelPacks: {
    title: "Panel Packs Admin",
    selectPack: "Select a pack to edit",
    createPack: "Create Pack",
    packName: "Pack Name",
    packNamePlaceholder: "e.g. Summer Comics, Horror Week",
    goesLiveOn: "Goes Live On",
    cancel: "Cancel",
    create: "Create",
    addPanel: "Add Panel",
    saveChanges: "Save Changes",
    deletePanel: "Delete Panel",
    noPanels: "No panels in this pack",
    day: "Day",
    count: "Count",
    panelImageUrl: "Panel Image URL",
    releaseKey: "Release Key",
    description: "Description",
    loading: "Loading...",
    saving: "Saving...",
    saved: "Saved successfully!",
    error: "Error occurred",
  },

  users: {
    title: "Users",
    totalUsers: "total users",
    inviteUser: "Invite User",
    searchPlaceholder: "Search by name, email, or ID...",
    columns: {
      id: "ID",
      status: "Status",
      user: "User",
      email: "Email",
      fullName: "Full Name",
      group: "Group",
      gold: "Gold",
      joinDate: "Joined",
      actions: "Actions",
    },
    actions: {
      viewDetails: "View Details",
      banUser: "Ban User",
      unbanUser: "Unban User",
      deleteUser: "Delete User",
      exportActivity: "Export Activity",
    },
    detail: {
      title: "User Detail",
      exportActivity: "Export Activity",
      tabs: {
        profile: "Profile",
        activities: "Activities",
        sessions: "Sessions",
        emails: "Emails",
        pages: "Pages",
        orders: "Orders",
        applications: "Applications",
        groups: "Groups",
        ios: "iOS",
      },
      comingSoon: "Coming soon",
    },
    edit: {
      title: "Edit User",
      saveChanges: "Save Changes",
      fullName: "Full Name",
      username: "Username",
      description: "Description",
      country: "Country",
      uiLanguage: "UI Language",
      releasesLanguage: "Releases Language",
      betaAccess: "Beta Access",
      enablePms: "Enable PMs",
      hideAiResults: "Hide AI Results",
      displayRealName: "Display Real Name",
      displayDonations: "Display Donations",
      disablePayments: "Disable Payments",
      userArchetype: "User Archetype",
      updated: "User updated",
    },
    ban: {
      title: "Ban User",
      unbanTitle: "Unban User",
      reason: "Reason",
      reasonPlaceholder: "Reason for ban...",
      endDate: "End Date",
      endDateHelp: "Leave empty for permanent ban",
      deleteComments: "Delete all comments",
      deleteForumPosts: "Delete all forum posts",
      confirmBan: "Ban User",
      confirmUnban: "Unban",
      banned: "User banned",
      unbanned: "User unbanned",
    },
    delete: {
      title: "Delete User",
      confirmMessage: "Are you sure you want to delete this user? This is a soft delete — the account will be deactivated but data will be retained.",
      confirmButton: "Delete User",
      deleted: "User deleted",
    },
    invite: {
      title: "Invite User",
      subtitle: "Send an invitation to a new user",
      fullName: "Full Name",
      username: "Username",
      email: "Email",
      isCreator: "Is Creator",
      romanName: "Roman Name",
      language: "Language",
      country: "Country",
      artistType: "Artist Type",
      serviceFee: "GC Service Fee %",
      donationFee: "GC Donation Fee %",
      duration: "Duration (months)",
      sendInvitation: "Send Invitation",
      invited: "User invited successfully",
    },
  },
};
